import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import Global from '../../../store/global-selectors';
import {
  NotificationService,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_INFO,
} from 'ui-components/services/notification-service';
import ReuseableGridButton from '../../../components/grid-header/reusable-grid-button';
import { FulfillmentContext } from '../context';
import { retryNotificationsPromise } from '../../../store/send-notifications/send-notifications.api';
import { messages as notificationMessages } from '../../../store/send-notifications/messages';

const messages = defineMessages({
  sendNotification: {
    defaultMessage: 'Send Notifications',
    id: 'AwqhKB',
    description: 'fulfillmentGrid.sendNotifications',
  },
});

export const SendNotificationsButton = () => {
  const { selectedFulfillmentIds, refreshGridData } = useContext(FulfillmentContext);
  const selectedFulfillmentPlanIds = useSelector((state) =>
    Global.selectEntitiesFPIdsByFulfillmentIds(state, {
      fulfillmentIds: selectedFulfillmentIds,
    }),
  );
  const oneOrMoreShipmentSelected = selectedFulfillmentIds.length > 0;
  const disabled = !oneOrMoreShipmentSelected;
  const sendShipmentNotification = useCallback(() => {
    NotificationService.showNotification({
      title: <FormattedMessage {...notificationMessages.sendingShipmentNotificationTitle} />,
      notificationType: NOTIFICATION_TYPE_INFO,
      content: <FormattedMessage {...notificationMessages.sendingShipmentNotificationContent} />,
      duration: 3000,
    });

    // yes this is the same action as notify-marketplaces. The BE both sends notifications and notifies marketplaces.
    retryNotificationsPromise(selectedFulfillmentPlanIds)
      .then(() => {
        NotificationService.showNotification({
          title: <FormattedMessage {...notificationMessages.shipmentNotificationSuccessTitle} />,
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          content: <FormattedMessage {...notificationMessages.shipmentNotificationSuccessContent} />,
          duration: 3000,
        });
        refreshGridData();
      })
      .catch(() => {
        NotificationService.showNotification({
          title: <FormattedMessage {...notificationMessages.shipmentNotificationErrorTitle} />,
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...notificationMessages.shipmentNotificationErrorContent} />,
          duration: 3000,
        });
      });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFulfillmentIds, refreshGridData]);

  return (
    <ReuseableGridButton
      actionHandler={sendShipmentNotification}
      disable={disabled}
      messageDescriptor={messages.sendNotification}
      theme='tertiary'
    />
  );
};
